// import { Controller } from "@hotwired/stimulus"
// import Masonry from "masonry-layout"
// import imagesLoaded from "imagesloaded"


// // The only thing necessary for an image or video for being lazy loaded is adding the .lazy class.

// // Connects to data-controller="masonry-grid"
// export default class extends Controller {
//   masonryInstance = null
//   lazyloadMedia = null
//   handleResizeBound = null

//   connect() {
//     this.lazyloadMedia = this.element.querySelectorAll('.lazy')
//     this.initializeLazyLoad()
//     this.initializeMasonry()

//     // Bind the handleResize function to ensure the correct context when called
//     this.handleResizeBound = this.handleResize.bind(this)
//     window.addEventListener('resize', this.handleResizeBound)
//   }

//   disconnect() {
//     window.removeEventListener('resize', this.handleResizeBound)
//     if (this.masonryInstance) {
//       this.destroyMasonry()
//     }
//   }

//   initializeMasonry() {
//     this.startMasonry()
//     // if (!this.masonryInstance) {
//     //   this.startMasonry()
//     // } else if (this.masonryInstance) {
//     //   this.destroyMasonry()
//     // }
//   }

//   startMasonry() {
//     imagesLoaded(this.element, () => {
//       this.masonryInstance = new Masonry(this.element, {
//         itemSelector: '.grid-item',
//         columnWidth: '.grid-sizer',
//         percentPosition: true
//       })
//       setTimeout(() => {
//         if (this.masonryInstance) {
//           this.masonryInstance.layout()
//         }
//       }, 500)
//     })
//   }

//   destroyMasonry() {
//     if (this.masonryInstance) {
//       this.masonryInstance.destroy()
//       this.masonryInstance = null
//     }
//   }

//   handleResize() {
//     this.initializeMasonry()
//   }

//   // isNotMobile() {
//   //   // return !('ontouchstart' in window || navigator.maxTouchPoints > 0) && window.innerWidth > 767
//   //   // return !(window.innerWidth <= 767 || 'ontouchstart' in window || navigator.maxTouchPoints > 0)
//   //   return window.innerWidth > 600
//   // }
//   // isNotMobile() {
    
//   // }

//   initializeLazyLoad() {
//     if ('IntersectionObserver' in window) {
//       this.initializeIntersectionObserver()
//     } else {
//       this.initializeFallbackLazyLoad()
//     }
//   }

//   initializeIntersectionObserver() {
//     let mediaObserver = new IntersectionObserver((entries, observer) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           let media = entry.target
//           this.loadMedia(media)
//           mediaObserver.unobserve(media)
//         }
//       })
//     })

//     this.lazyloadMedia.forEach((image) => {
//       mediaObserver.observe(image)
//     })
//   }

//   initializeFallbackLazyLoad() {
//     var lazyloadThrottleTimeout
//     // Fixed the scope of lazyloadMedia within this function
//     var lazyloadMedia = this.lazyloadMedia

//     function lazyload() {
//       if (lazyloadThrottleTimeout) {
//         clearTimeout(lazyloadThrottleTimeout)
//       }

//       lazyloadThrottleTimeout = setTimeout(function() {
//         var scrollTop = window.pageYOffset

//         lazyloadMedia.forEach(function(img) {
//           if (img.offsetTop < (window.innerHeight + scrollTop)) {
//             img.src = img.dataset.src
//             img.classList.remove('lazy')
//           }
//         })

//         if (lazyloadMedia.length === 0) {
//           document.removeEventListener('scroll', lazyload)
//           window.removeEventListener('resize', lazyload)
//           window.removeEventListener('orientationChange', lazyload)
//         }
//       }, 20)
//     }

//     document.addEventListener('scroll', lazyload)
//     window.addEventListener('resize', lazyload)
//     window.addEventListener('orientationChange', lazyload)
//   }

//   loadMedia(media) {
//     media.src = media.dataset.src
//     media.classList.remove('lazy')

//     media.addEventListener('load', () => {
//       if (this.masonryInstance) {
//         this.masonryInstance.layout()
//       }
//     })
//   }
// }


import { Controller } from "@hotwired/stimulus"
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"

// Connects to data-controller="masonry-grid"
export default class extends Controller {
  masonryInstance = null
  lazyloadMedia = null
  handleResizeBound = null

  connect() {
    this.lazyloadMedia = this.element.querySelectorAll('.lazy')
    this.initializeLazyLoad()
    this.initializeMasonry()

    // Bind the handleResize function to ensure the correct context when called
    this.handleResizeBound = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResizeBound)
  }

  disconnect() {
    window.removeEventListener('resize', this.handleResizeBound)
    if (this.masonryInstance) {
      this.masonryInstance.destroy()
      this.masonryInstance = null
    }
  }

  initializeMasonry() {
    imagesLoaded(this.element, () => {
      this.masonryInstance = new Masonry(this.element, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
      })
      setTimeout(() => {
        if (this.masonryInstance) {
          this.masonryInstance.layout()
        }
      }, 500)
    })
  }

  handleResize() {
    if (this.masonryInstance) {
      this.masonryInstance.layout()
    }
  }

  initializeLazyLoad() {
    if ('IntersectionObserver' in window) {
      this.initializeIntersectionObserver()
    } else {
      this.initializeFallbackLazyLoad()
    }
  }

  initializeIntersectionObserver() {
    let mediaObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let media = entry.target
          this.loadMedia(media)
          mediaObserver.unobserve(media)
        }
      })
    })

    this.lazyloadMedia.forEach((image) => {
      mediaObserver.observe(image)
    })
  }

  initializeFallbackLazyLoad() {
    var lazyloadThrottleTimeout
    var lazyloadMedia = this.lazyloadMedia

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout)
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset

        lazyloadMedia.forEach(function(img) {
          if (img.offsetTop < (window.innerHeight + scrollTop)) {
            img.src = img.dataset.src
            img.classList.remove('lazy')
          }
        })

        if (lazyloadMedia.length === 0) {
          document.removeEventListener('scroll', lazyload)
          window.removeEventListener('resize', lazyload)
          window.removeEventListener('orientationChange', lazyload)
        }
      }, 20)
    }

    document.addEventListener('scroll', lazyload)
    window.addEventListener('resize', lazyload)
    window.addEventListener('orientationChange', lazyload)
  }

  loadMedia(media) {
    media.src = media.dataset.src
    media.classList.remove('lazy')

    media.addEventListener('load', () => {
      if (this.masonryInstance) {
        this.masonryInstance.layout()
      }
    })
  }
}
